import { PageOptions, GroupOptions, PostFrequency, PostType } from 'src/DTO/FacebookPost.type';
import { getURL } from 'src/utils/facebookPostUtils';
import { PostScheduleStatus } from './types';

export const PageGroupOptions: Record<PageOptions | GroupOptions, string> = {
  [PageOptions.DELLA_DIAKMUNKA]: 'https://www.facebook.com/delladiakmunka',
  [GroupOptions.DIAKMUNKA_BUDAPEST]: 'https://www.facebook.com/groups/1139651699543550',
  [GroupOptions.DIAKMUNKA_DEBRECEN]: 'https://www.facebook.com/groups/323651004905323',
  [GroupOptions.DIAKMUNKA_GYOR]: 'https://www.facebook.com/groups/881449765759080',
  [GroupOptions.DIAKMUNKA_PECS]: 'https://www.facebook.com/groups/727618741288223',
  [GroupOptions.DIAKMUNKA_NYIREGYHAZA]: 'https://www.facebook.com/groups/430939691547075',
  [GroupOptions.DIAKMUNKA_SZEGED]: 'https://www.facebook.com/groups/452307842849654',
  [GroupOptions.DIAKMUNKA_MISKOLC]: 'https://www.facebook.com/groups/512183656679022',
  [GroupOptions.DIAKMUNKA_BALATON]: 'https://www.facebook.com/groups/1239254589824881',
  [GroupOptions.DIAKMUNKA_SOPRON]: 'https://www.facebook.com/groups/1211710932683914',
  [GroupOptions.DIAKMUNKA_INFORMATIKA]: 'https://www.facebook.com/groups/512399987688946',
  [GroupOptions.DIAKMUNKA_KOZGAZDASZ]: 'https://www.facebook.com/groups/580004890226012',
  [GroupOptions.DIAKMUNKA_FESZTIVALOKON]: 'https://www.facebook.com/groups/212204650613877',
};

export const STEPS = [1, 2, 3, 4, 5];

export const DEFAULTS = {
  NUMBER_OF_POSTS: 3,
  PAGE: [
    {
      id: '102369075290282',
      name: PageOptions.DELLA_DIAKMUNKA,
      url: getURL(PageOptions.DELLA_DIAKMUNKA),
    },
  ],
  GROUP: [],
  PAGE_OPTIONS: [PageOptions.DELLA_DIAKMUNKA],
  GROUP_OPTIONS: [],
  POST_SCHEDULE: {
    jobId: '',
    frequency: PostFrequency.DAILY,
    postType: PostType.POST,
    name: '',
    city: '',
    startTime: '',
    startDate: '',
    endDate: '',
    status: PostScheduleStatus.ACTIVE,
    facebookPosts: [],
    pageData: [],
    groupData: [],
  },
};
